import { render, staticRenderFns } from "./AppBindezFooterLogo.vue?vue&type=template&id=27024dc4&scoped=true&"
import script from "./AppBindezFooterLogo.vue?vue&type=script&lang=js&"
export * from "./AppBindezFooterLogo.vue?vue&type=script&lang=js&"
import style0 from "./AppBindezFooterLogo.vue?vue&type=style&index=0&id=27024dc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27024dc4",
  null
  
)

export default component.exports